/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Keen_Heron_SoarInputs */

const en_bright_keen_heron_soar = /** @type {(inputs: Bright_Keen_Heron_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentiality Level`)
};

const de_bright_keen_heron_soar = /** @type {(inputs: Bright_Keen_Heron_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertraulichkeitsstufe`)
};

/**
* | output |
* | --- |
* | "Confidentiality Level" |
*
* @param {Bright_Keen_Heron_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_keen_heron_soar = /** @type {((inputs?: Bright_Keen_Heron_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Keen_Heron_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_keen_heron_soar(inputs)
	return de_bright_keen_heron_soar(inputs)
});